import {useLocation, useNavigate} from 'react-router-dom';
import Filtros from './Filtros';
import Filtro from './Filtro';
import React, { useState, useEffect, useCallback } from 'react';
import ObjetoParticipante from './ObjetoParticipante';

function ObjetoParticipantes() {

  const location = useLocation();
  const [estado, setEstado] = useState(-1);
  // const [entidadeId, setEntidadeId] = useState( location.state.entidade_id || -1);
  const [fiscalizacao, setFiscalizacao] = useState(location?.state.operacao_id || 214);
  const [objetoId, setobjetoId] = useState(location?.state.objetoId || 214);
  // console.log("SITUACAO OBJETO STATE",location.state)
  const [fiscalizacaoOperacao, setFiscalizacaoOperacao] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [fiscalizacoes, setFiscalizacoes] = useState([{ value: "...", label: "..." }]);
  const [updateCounter, setUpdateCounter] = useState(0);

 const navigate = useNavigate()

  const fetchParticipantes = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/situacao/objeto/participante/${fiscalizacao}/objetoid/${objetoId}`)
    const json = await data.json()
    setParticipantes(json)
  }


  const fetchFiscalizacoes = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes`)
    const json = await data.json()
    setFiscalizacoes(json)
  }

  const fetchFiscalizacaoOperacao = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setFiscalizacaoOperacao(json)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setUpdateCounter((prev) => { return prev + 1 })
    }, 40 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // fetchEstados()
    fetchFiscalizacoes()
  }, []);

  useEffect(() => {
    fetchFiscalizacaoOperacao()
    //fetchparticipantes()
    fetchParticipantes()
  }, [fiscalizacao, estado, updateCounter]);

  const handleEstadoChange = (e) => {
    const valor = e.target.value
    const estadoIndex = e.nativeEvent.target.selectedIndex;
    const estadoText = e.nativeEvent.target[estadoIndex].text;
    const estadoValue = e.nativeEvent.target[estadoIndex].value;
    setEstado(estadoValue)
  }
  const handleFiscalizacaoChange = (e) => {
    const valor = e.target.value
    setFiscalizacao(valor)
  }

  const getPieData = (dado, tipo) => {

    const nao_respondidas = dado?.total - dado?.respondidas
    if (tipo === 'objeto') {
      return [
        { name: 'Respondidas', y: dado?.respondidas, id_objeto: dado.id_objeto },
        { name: 'Não Respondidas', y: nao_respondidas, id_objeto: dado.id_objeto }
      ]
    } else if (tipo === 'entidade') {
      console.log(dado)
      return [
        { name: 'Respondidas', y: dado?.respondidas, id_entidade: dado.id_entidade },
        { name: 'Não Respondidas', y: nao_respondidas, id_entidade: dado.id_entidade }
      ]
    }
  }

  const getRespondidasPercentual = (parte, todo) => {
    const respondidas = parseInt(parte) || 0
    const respondidas_total = parseInt(todo) || 1

    let valor = respondidas / respondidas_total
    valor = valor * 100
    valor = valor.toLocaleString('pt-BR', {
      minimumIntegerDigits: 2,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    })
    return valor
  }

  const participanteClick = (e) => {
    const x = e?.point
    console.log("CLICK", x)
    // participantes.find(y => y === x?.id_entidade)
  }

  const changeEstadoHandler = (codigo) => {
    setEstado(codigo)
  }

  return (

    <div className="materiais">
      
      {/* <Filtros> */}
        {/* <Filtro key="filtroDestino" id="filtroDestino" name="Destino" data={destinos} onChange={handleDestinoChange} /> */}
        {/* <Filtro key="filtroEstado" id="filtroEstado" name="Estado" data={estados} value={estado} onChange={handleEstadoChange} /> */}
        {/* <Filtro key="filtroFiscalizacao" id="filtroFiscalizacao" name="Fiscalizações" data={fiscalizacoes} onChange={handleFiscalizacaoChange} /> */}
      {/* </Filtros> */}

      <div className="back-button sombra" onClick={() => navigate(-1)}><span>Voltar para Visão por Entidade</span></div>


      <div className="main_layout">
        <div className="graficos-situacao" id="graficos-situacao">
          {participantes.map(x => {
            return <ObjetoParticipante key={x.id_objeto+x.descricao_objeto+x.respondidas} participantes={x} click={participanteClick} />
          })}
        </div>
      </div>
    </div>
  );
}

export default ObjetoParticipantes;
